import { memo, useState } from "react";
import { Button, Modal, Radio, Space } from "antd";
import IntlMessages from "../Message/IntlMessages";
import ModalTemplate1 from "./ModalTemplate/ModalTemplate1";
import update from "immutability-helper";
import without from "lodash/without";

const FormFatca = ({ code, close, actions, ...modalProps }) => {
  const [answers, setAnswers] = useState([null, null]);

  function onAnswerChange(questionIndex, answer) {
    setAnswers((answers) => update(answers, { [questionIndex]: { $set: answer } }));
  }

  function onAccept() {
    close();
    const payload = answers.reduce(
      (acc, answer, index) => ({
        ...acc,
        [`question${index + 1}`]: answer,
      }),
      {}
    );
    actions?.onAccept && actions.onAccept(payload);
  }

  function onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  const questions = [
    {
      question: <IntlMessages id="fatca.questions.1" />,
      questionDescriptions: [
        <IntlMessages id="fatca.questions.1.desc.1" />,
        <IntlMessages id="fatca.questions.1.desc.2" />,
        <IntlMessages id="fatca.questions.1.desc.3" />,
      ],
    },
    {
      question: <IntlMessages id="fatca.questions.2" />,
      questionDescriptions: [
        <IntlMessages id="fatca.questions.2.desc.1" />,
        <IntlMessages id="fatca.questions.2.desc.2" />,
        <IntlMessages id="fatca.questions.2.desc.3" />,
        <IntlMessages id="fatca.questions.2.desc.4" />,
        <IntlMessages id="fatca.questions.2.desc.5" />,
      ],
    },
  ];

  return (
    <Modal {...modalProps}>
      <ModalTemplate1
        className="resend-email-modal"
        title={<IntlMessages id="fatca.form.title" />}
        bodyClass="pb-2"
        body={
          <>
            {questions.map(({ question, questionDescriptions }, questionIndex) => (
              <div key={questionIndex} className="form-question">
                <div className="title-question">{question}</div>
                <ul className="detail-fatca">
                  {questionDescriptions.map((questionDescription, index) => (
                    <li key={index}>{questionDescription}</li>
                  ))}
                </ul>
                <div className="fatca-choose">
                  <Radio.Group
                    value={answers[questionIndex]}
                    onChange={(evt) => onAnswerChange(questionIndex, evt.target.value)}
                  >
                    <Radio value={true}>
                      <IntlMessages id="global.yes" />
                    </Radio>
                    <Radio value={false}>
                      <IntlMessages id="global.no" />
                    </Radio>
                  </Radio.Group>
                </div>
              </div>
            ))}
          </>
        }
        footer={
          <div className="d-flex-main">
            <Space size={20}>
              <Button className="btn button-ktb-line px-4" type="primary" style={buttonWidth} onClick={onCancel}>
                <IntlMessages id="global.cancel" />
              </Button>
              <Button
                className="btn button-ktb-main btn-block px-4"
                type="primary"
                style={buttonWidth}
                onClick={onAccept}
                disabled={without(answers, null).length !== 2}
              >
                <IntlMessages id="global.confirm" />
              </Button>
            </Space>
          </div>
        }
      />
    </Modal>
  );
};

export default memo(FormFatca);

const buttonWidth = {
  width: 140,
};
